<template>
  <panel>
    <h3 v-if="hasDuplicates" class="text-danger font-weight-bold">
      <span>
        Uwaga: Wniosek z takimi danymi został już złożony. W przypadku konieczności edycji proszę o kontakt&nbsp;
      </span>

      <span v-if="submitToSchool">ze&nbsp;szkołą.</span>

      <span v-else>z&nbsp;Wydziałem Oświaty i&nbsp;Wychowania UM.</span>
    </h3>

    <h3>
      Po kliknięciu "Podpisz przez EPUAP" zostaniesz przekierowany do serwisu
      <a href="https://pz.gov.pl/">pz.gov.pl</a> w celu bezpiecznego podpisania dokumentu profilem&nbsp;zaufanym lub
      podpisem&nbsp;kwalifikowanym.
    </h3>

    <post-form
      class="float-right"
      button-class="btn-primary"
      text="Podpisz przez EPUAP"
      target="_self"
      :disabled="hasDuplicates"
      :url="signLink"
    />
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import { config } from '@/utils/config';

// @vuese
// Podpisywanie wniosku przez EPUAP
// @group epuap
export default {
  components: { Panel, PostForm },
  computed: {
    ...mapState({ document: state => state.document.data, hasNoDuplicates: state => state.document.hasNoDuplicates }),
    signLink() {
      return `${config.epuapURL}/sign/prepare/${this.$route.params.documentId}`;
    },
    hasDuplicates() {
      return !this.hasNoDuplicates || (document.data && document.data.duplicatedDataValidation === false);
    }
  }
};
</script>
